
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CompanyQueryModel extends Model<CompanyQueryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'keyword', type: 'string' },
		{ name: 'vatNumber', type: 'string' },
		{ name: 'nace', type: 'number' },
		{ name: 'businessName', type: 'string' },
		{ name: 'phoneNumber', type: 'string' },
		{ name: 'zipCode', type: 'string[]', isArray: true }
	];
	[key: string]: any;
	
	public keyword: string;
	public vatNumber: string;
	public nace?: number;
	public businessName: string;
	public phoneNumber: string;
	public zipCode: string[];
    
	constructor(){
		super();
		this.keyword = '';
		this.vatNumber = '';
		this.nace = undefined;
		this.businessName = '';
		this.phoneNumber = '';
		this.zipCode = [];
		
	}
	getProperties(){
		return CompanyQueryModel.classProperties;
	}
}

